import React, { useState, useMemo } from 'react';
import { usePage } from '@avinet/react-adaptive-cms';
import Cookies from 'cookies-js';
import './News.scss';

const currentNewsVersion = 1;

const hasAccepted = () => {
  const newsCookie = JSON.parse(Cookies.get('newsAccept') || '{}');

  return newsCookie && newsCookie.version === currentNewsVersion && newsCookie.accepted === 'y';
}

const accept = () => {
  Cookies.set('newsAccept', JSON.stringify({ version: currentNewsVersion, accepted: 'y' }), { expires: 50 * 24 * 60 * 60 });
};

const News = () => {
  const page = usePage('news');
  const [show, setShow] = useState(!hasAccepted());

  const display = useMemo(() => {
    return show && page && !page.is404 && page.is_active;
  }, [show, page]);

  const dismiss = () => {
    accept();
    setShow(false);
  };

  return !display ? null : (
    <div className="news--container">
      <div>
        <div dangerouslySetInnerHTML={{ __html: page?.content }} />
        <button className="btn btn-primary" onClick={dismiss}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default News;